import {createContext} from 'react'

export const ProfitabilityContext = createContext({
  isFullView: false,
  ordersOverviewData: [] as any,
  isOrdersOverviewDataLoading: false,
  onOrdersOverviewDateChange: (startDate: any, endDate: any) => {},
  customersGroupsChartData: [] as any,
  isCustomersGroupsChartLoading: false,
  onDateChangeCustomersGroupsChart: (startDate: any, endDate: any) => {},
  onChangeCustomerGroupCustomersGroupsFilter: (values: any[]) => {},
  profitabilityData: [],
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onPageChange: (page: number) => {},
  onChangeCustomerGroupFilter: (values: any[]) => {},
  pagination: {},
  customersGroupsFilters: {},
  onDateChangeCustomers: (startDate: any, endDate: any) => {},
  onSortingChangeCustomersGroups: (sortBy: string, sortOrder: string) => {},

  onDateChangeCustomersGroups: (startDate: any, endDate: any) => {},
  onDateChangeProfitabilitySummary: (startDate: any, endDate: any) => {},

  salesReps: [],
  isSalesRepDropdownLoading: false,
  onChangeSalesRepFilter: (values: any[]) => {},
  onDownloadCSV: () => {},

  dateRangeLable: '',
  setDateRangeLable: (label: string) => {},

  CustomersGroupsData: [],
  isCustomersGroupsLoading: false,

  profitabilitySummaryData: {} as any,
  isProfitabilitySummaryLoading: false,

  customerGroups: [],
  isCustomerGroupsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  allEntityPerformanceChartData: [] as any,
  isAllEntityPerformanceChartDataLoading: false,
  onAllEntityPerformanceChartIdChange: (entityId: string) => {},
  onAllEntityPerformanceChartViewChange: (e: any) => {},
  onAllEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  allEntityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (entityId: string) => {},
  onProfitTrendViewChange: (e: any) => {},
  onProfitTrendDateRangeChange: (startDate: any, endDate: any) => {},
  profitTrendFilters: {} as any,

  // Customer Type Profit Trend Modal Data
  customerTypeProfitTrendChartData: [] as any,
  customerTypeProfitTrendKpiData: {} as any,
  customerTypeProfitTrendWeeklyBreakdownData: [] as any,
  isCustomerTypeProfitTrendDataLoading: false,
  onCustomerTypeProfitTrendIdChange: (id: string) => {},
})

export const SupplierReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  suppliers: [] as any[],
  isSuppliersLoading: false,
  onChangeSupplierFilter: (value: any) => {},
  onDownloadCSV: () => {},

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const ClassificationReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  onChangeClassificationFilter: (value: any) => {},
  onDownloadCSV: () => {},

  classifications: [] as any[],
  isClassificationsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const ProductWiseReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onDateChangeCustomers: (startDate: any, endDate: any) => {},

  classifications: [] as any[],
  isClassificationsDropdownLoading: false,
  suppliers: [] as any[],
  isSuppliersDropdownLoading: false,
  products: [] as any[],
  productsPagination: {} as any,
  isProductsLoading: false,
  onProductsFilterPageChange: (page: number) => {},
  onProductsFilterSearch: (value: string) => {},
  onProductsFilterClassificationChange: (value: any) => {},
  onChangeClassificationFilter: (value: any) => {},
  onChangeSupplierFilter: (value: any) => {},
  onChangeProductFilter: (value: any) => {},
  onDownloadCSV: () => {},

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const CustomerRepReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepTypeFilter: (value: any) => {},

  salesRepTypes: [] as any[],
  isSalesRepDropdownLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const CustomerReportContext = createContext({
  customerGroupData: [],
  isCustomerGroupLoading: false,
  handleCustomerGroupReportDateChange: (startDate: any, endDate: any) => {},
  customerGroupReportFilters: {},
  onSortingChangeCustomerGroupReport: (sortBy: string, sortOrder: string) => {},
  onChangeCustomerGroupFilter: (value: any) => {},

  customerTypeData: [],
  isCustomerTypeLoading: false,
  handleCustomerTypeReportDateChange: (startDate: any, endDate: any) => {},
  customerTypeReportFilters: {},
  onSortingChangeCustomerTypeReport: (sortBy: string, sortOrder: string) => {},

  customerGroups: [],
  isCustomerGroupsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  customerTypeEntityPerformanceChartData: [] as any,
  isCustomerTypeEntityPerformanceChartDataLoading: false,
  onCustomerTypeEntityPerformanceChartIdChange: (entityId: string) => {},
  onCustomerTypeEntityPerformanceChartViewChange: (e: any) => {},
  onCustomerTypeEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  customerTypeEntityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},

  // Customer Type Profit Trend Modal Data
  customerTypeProfitTrendChartData: [] as any,
  customerTypeProfitTrendKpiData: {} as any,
  customerTypeProfitTrendWeeklyBreakdownData: [] as any,
  isCustomerTypeProfitTrendDataLoading: false,
  onCustomerTypeProfitTrendIdChange: (id: string) => {},
})

export const PurchaserReportContext = createContext({
  purchaserReportData: [],
  isPurchaserReportLoading: false,
  filters: {},
  onSortingChange: (key: string, order: string) => {},
  handlePurchaserReportDateChange: (startDate: any, endDate: any) => {},

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const PurchaserByBrandReportContext = createContext({
  purchaserReportData: [],
  isPurchaserReportLoading: false,
  filters: {},
  onSortingChange: (key: string, order: string) => {},
  handlePurchaserReportDateChange: (startDate: any, endDate: any) => {},

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})

export const OrderReportContext = createContext({
  ordersReportData: [],
  isOrdersReportLoading: false,
  filters: {} as any,
  hasOrderFilterApplied: false,
  onSearch: (value: string) => {},
  onSortingChange: (sortBy: string, sortOrder: string) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepFilter: (values: any[]) => {},
  onChangeCustomerGroupFilter: (values: any[]) => {},
  onDownloadCSV: () => {},
  onProfitPercentageChange: (value: string) => {},
  onResetFilters: () => {},

  salesReps: [] as any[],
  isSalesRepDropdownLoading: false,

  customerGroups: [] as any[],
  isCustomerGroupsLoading: false,
})

export const BrandReportContext = createContext({
  reportData: [],
  pagination: {},
  isLoading: false,
  filters: {},
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onPageChange: (page: number) => {},
  onDateChange: (startDate: any, endDate: any) => {},
  onChangeBrandFilter: (value: any) => {},
  onChangePurchaserFilter: (value: any) => {},
  onDownloadCSV: () => {},

  brands: [],
  isBrandsLoading: false,
  purchasers: [],
  isPurchasersLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (entityId: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  // Profit Trend Modal Data
  profitTrendChartData: [] as any,
  profitTrendKpiData: {} as any,
  profitTrendWeeklyBreakdownData: [] as any,
  isProfitTrendDataLoading: false,
  onProfitTrendIdChange: (id: string) => {},
})
